import DesktopNav from "./DesktopNav";
import MobileNav from "./MobleNav";

//https://kenudeh.hashnode.dev/how-to-build-a-responsive-navigation-menu-with-react
const NavigationBar = () => {

    return(
        <div>
            <DesktopNav/>
            <MobileNav/>
        </div>
    )
};

export default NavigationBar;